export const CATEGORY_GRADIENT_CLASSNAME: Record<string, string> = {
  软件开发:
    "from-[var(--category-software-from)] via-[var(--category-software-via)] to-[var(--category-software-to)]",
  人工智能:
    "from-[var(--category-ai-from)] via-[var(--category-ai-via)] to-[var(--category-ai-to)]",
  技术琐事:
    "from-[var(--category-misc-from)] via-[var(--category-misc-via)] to-[var(--category-misc-to)]",
  生活闲暇:
    "from-[var(--category-life-from)] via-[var(--category-life-via)] to-[var(--category-life-to)]",
};
